import { VERA, SOCIALS, LOGO } from "@/lib/constants";
import { Instagram, Music2, Facebook, MapPin, Leaf } from "lucide-react";

export const AboutVera = ({ compact = false }) => {
  return (
    <section
      data-testid="about-vera-section"
      className="bg-white rounded-3xl p-6 sm:p-10 shadow-[0_8px_30px_rgba(44,62,53,0.04)] border border-[#E5E7E1]"
    >
      <div className="flex flex-col sm:flex-row gap-6 sm:gap-8 items-start">
        <div className="shrink-0 mx-auto sm:mx-0">
          <div className="relative">
            <img
              src={VERA.photo}
              alt="Vera Budé"
              data-testid="vera-photo"
              className="w-28 h-28 sm:w-36 sm:h-36 rounded-2xl object-cover"
            />
            <span className="absolute -bottom-3 -right-3 bg-[#E08B84] text-white rounded-full p-2 shadow-md">
              <Leaf size={18} />
            </span>
          </div>
        </div>

        <div className="flex-1">
          <p className="text-sm tracking-widest uppercase text-[#6B8E74] font-medium mb-3">
            Jouw welzijnscheck wordt aangeboden door
          </p>
          <img
            src={LOGO}
            alt="Gezond met Vera logo"
            data-testid="vera-logo"
            className="h-20 w-auto rounded-2xl mb-3"
          />
          <h3 className="text-2xl sm:text-3xl text-[#2C3E35] mb-1">
            {VERA.brand}
          </h3>
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-[#5B6B61] mb-4">
            <span className="font-medium">{VERA.role}</span>
            <span className="text-[#8FA38C]">•</span>
            <span className="inline-flex items-center gap-1">
              <MapPin size={14} /> {VERA.location}
            </span>
          </div>

          {!compact && (
            <div className="space-y-3 text-[#5B6B61] leading-relaxed">
              <p>
                Hallo, ik ben <strong className="text-[#2C3E35]">Vera Budé</strong> van
                Gezond met Vera uit Genk.
              </p>
              <p>
                Als orthomoleculair therapeut begeleid ik mensen al jarenlang bij het
                verbeteren van hun gezondheid, energie en welzijn via voeding, leefstijl
                en persoonlijke begeleiding.
              </p>
              <p>
                Met deze welzijnscheck wil ik beter begrijpen welke gezondheidsuitdagingen
                mensen vandaag ervaren en deelnemers helpen om meer inzicht te krijgen in
                hun eigen gezondheid.
              </p>
              <p>
                Deelname is volledig vrijblijvend en je ontvangt onmiddellijk jouw
                persoonlijke welzijnsscore.
              </p>
            </div>
          )}

          <div className="flex flex-wrap gap-3 mt-5">
            <a
              href={SOCIALS.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="vera-instagram-link"
              className="inline-flex items-center gap-2 text-sm text-[#2C3E35] bg-[#F2F4EF] hover:bg-[#E5E7E1] px-4 py-2 rounded-full transition-colors"
            >
              <Instagram size={16} /> Instagram
            </a>
            <a
              href={SOCIALS.tiktok}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="vera-tiktok-link"
              className="inline-flex items-center gap-2 text-sm text-[#2C3E35] bg-[#F2F4EF] hover:bg-[#E5E7E1] px-4 py-2 rounded-full transition-colors"
            >
              <Music2 size={16} /> TikTok
            </a>
            <a
              href={SOCIALS.facebook}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="vera-facebook-link"
              className="inline-flex items-center gap-2 text-sm text-[#2C3E35] bg-[#F2F4EF] hover:bg-[#E5E7E1] px-4 py-2 rounded-full transition-colors"
            >
              <Facebook size={16} /> Facebook
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
